/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardSearchControllerSearch400,
  DashboardSearchControllerSearch401,
  DashboardSearchControllerSearch429,
  DashboardSearchControllerSearch500,
  DashboardSearchControllerSearchParams,
  DashboardSearchResponse,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Fans out across eight trigram-indexed entity types in a single request and returns a paginated, score-sorted list. Matching is fuzzy and typeahead-friendly — even single-character keywords surface relevant hits. Transactions are emitted only when the keyword matches a `txn_…` publicId or a Stripe `pi_…` payment-intent id — both short-circuit to an exact-equality lookup that bypasses the trigram fan-out. Results are capped per type server-side so one type cannot crowd out the rest, then paged with `(page, limit)`. `federationId` is optional: when supplied the search is scoped to that single federation; when omitted it spans the whole platform (every federation under `platformId`). Each result section requires the matching READ capability on the requested scope (connection-aware — capabilities held through an active platform connection admit the connected target); sections the caller lacks are silently dropped, and a scope with no admitted section returns an empty page rather than 403.
 * @summary Global search across the dashboard (users, tournaments, licenses, clubs, leagues, teams, platforms, federations, transactions)
 */
export const dashboardSearchControllerSearch = (
  params: DashboardSearchControllerSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardSearchResponse>(
    { url: `/api/dashboard/v1/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardSearchControllerSearchQueryKey = (
  params: DashboardSearchControllerSearchParams
) => {
  return [`/api/dashboard/v1/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardSearchControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardSearchControllerSearch>>,
  TError = ErrorType<
    | DashboardSearchControllerSearch400
    | DashboardSearchControllerSearch401
    | DashboardSearchControllerSearch429
    | DashboardSearchControllerSearch500
  >,
>(
  params: DashboardSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardSearchControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardSearchControllerSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardSearchControllerSearch>>> = ({
    signal,
  }) => dashboardSearchControllerSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardSearchControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardSearchControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardSearchControllerSearch>>
>;
export type DashboardSearchControllerSearchQueryError = ErrorType<
  | DashboardSearchControllerSearch400
  | DashboardSearchControllerSearch401
  | DashboardSearchControllerSearch429
  | DashboardSearchControllerSearch500
>;

export function useDashboardSearchControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardSearchControllerSearch>>,
  TError = ErrorType<
    | DashboardSearchControllerSearch400
    | DashboardSearchControllerSearch401
    | DashboardSearchControllerSearch429
    | DashboardSearchControllerSearch500
  >,
>(
  params: DashboardSearchControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardSearchControllerSearch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardSearchControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardSearchControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardSearchControllerSearch>>,
  TError = ErrorType<
    | DashboardSearchControllerSearch400
    | DashboardSearchControllerSearch401
    | DashboardSearchControllerSearch429
    | DashboardSearchControllerSearch500
  >,
>(
  params: DashboardSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardSearchControllerSearch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardSearchControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardSearchControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardSearchControllerSearch>>,
  TError = ErrorType<
    | DashboardSearchControllerSearch400
    | DashboardSearchControllerSearch401
    | DashboardSearchControllerSearch429
    | DashboardSearchControllerSearch500
  >,
>(
  params: DashboardSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardSearchControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Global search across the dashboard (users, tournaments, licenses, clubs, leagues, teams, platforms, federations, transactions)
 */

export function useDashboardSearchControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardSearchControllerSearch>>,
  TError = ErrorType<
    | DashboardSearchControllerSearch400
    | DashboardSearchControllerSearch401
    | DashboardSearchControllerSearch429
    | DashboardSearchControllerSearch500
  >,
>(
  params: DashboardSearchControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardSearchControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardSearchControllerSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
